export default __webpack_public_path__ + "static/media/img-slide-3@2x.2d962cbe.jpeg";